import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchUserProfileRoles } from 'common/services/api/UserProfileRoles/UserProfileRoles.thunk';
import { Role } from 'common/types/Entities';
import { createMemoizedKeySelector } from 'common/utils/selectorUtils';

interface UserProfileRolesSliceState {
    userRolesByTenantId: Record<string, Role[]>;
    processing: string | false;
}

type StateWithUserProfileRoles = { userProfileRoles: UserProfileRolesSliceState };

const initialState: UserProfileRolesSliceState = {
    userRolesByTenantId: {},
    processing: false,
};

const userProfileRolesSlice = createSlice({
    name: 'userProfileRoles',
    initialState,

    reducers: (create) => ({
        clearUserProfileRoles: create.reducer(state => {
            state.userRolesByTenantId = {};
        })
    }),

    extraReducers: builder => {
        builder.addCase(fetchUserProfileRoles.pending, (state, args) => {
            state.processing = args.meta.arg.tenantId;
            state.userRolesByTenantId[args.meta.arg.tenantId] = [];
        });
        builder.addCase(fetchUserProfileRoles.fulfilled, (state, action: PayloadAction<Role[]>) => {
            state.processing = false;
            if(action.payload.length) {
                const tenantId = action.payload[0].tenantId;
                state.userRolesByTenantId = {
                    ...state.userRolesByTenantId,
                    [tenantId]: action.payload
                };
            }
        });
        builder.addCase(fetchUserProfileRoles.rejected, (state, args) => {
            state.processing = false;
            state.userRolesByTenantId[args.meta.arg.tenantId] = [];
        });
    }
});

// eslint-disable-next-line no-restricted-syntax
export default userProfileRolesSlice.reducer;
export const { clearUserProfileRoles } = userProfileRolesSlice.actions;

// Base selector for byTenantId state
const selectUserRolesByTenantIdState = (state: StateWithUserProfileRoles) => state.userProfileRoles.userRolesByTenantId;

// Memoized parameterized selector
export const selectUserProfileRolesByTenantId = createMemoizedKeySelector(selectUserRolesByTenantIdState);
export const selectProcessing = (state: StateWithUserProfileRoles) => state.userProfileRoles.processing;
